import styled from "styled-components";
import {Row, Select, DatePicker, TimePicker} from "antd";

export const SelectField = styled(Select)`
    width: 100%;
`;

export const FilterRow = styled(Row)`
    margin: 0 auto !important;
    padding: 10px 20px;
    position: absolute;
    z-index: 1;
    width: 100%;
    background: #ffffffbd;
`;

export const StatisticsContainer = styled.div`
    position: absolute;
    background: #ffffffe3;
    z-index: 3;
    bottom: 0px;
    right: 0px;
    padding: 15px;
    border-radius: 4px;
`;

export const StatusColor = styled.div`
    background-color: ${props => props.color};
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin: auto 5px auto 0px;
`;

export const MapContainer = styled.div`
    height: max(84.3vh, 500px);
    overflow: auto;
`;

export const TypeIcon = styled.div`
    margin-right: 5px;
`;

export const DatePickerField = styled(DatePicker)`
    margin-right: 5px;
    width: 9em;
`;

export const TimePickerField = styled(TimePicker)`
    margin-right: 5px;
    margin-top: 1px;
    width: 9em;
`;
